import React from 'react';
import '../Style/VersionItem.css';
import ArrowTooltips from '../../ToolTip';
import {AccuracyInsights} from '../../PopUp';
import {IPropsAccuracy} from '../Config/VersionItem.types';
import useAccuracy from '../Controllers/Accuracy.controller';
import CircularProgress from '@material-ui/core/CircularProgress';

const Accuracy = ({accuracy, insights = [], versionNumber, feature = '', isShowToolTip = true, id = null, onClick = null, isCanOpenEvalImages = false}:IPropsAccuracy) => {
    const {isClicked, openInsights, toolTipTitle, checkIfCanShowInsights} = useAccuracy({isShowToolTip, accuracy, insights });

    return (
        <>
            {isClicked && <AccuracyInsights
                insights={insights}
                close={openInsights}
                accuracy={accuracy}
                versionNumber={versionNumber}
                feature={feature}
                maxLenString={30}
                isCanOpenEvalImages={isCanOpenEvalImages}
                id={id}
                onClick={onClick}
            />}
            <ArrowTooltips
                title={toolTipTitle}
                placement='bottom'>
                {insights?.length > 0 && 'insight_type' in insights[0] && insights[0].insight_type === 'accuracy_in_progress' ? <CircularProgress style={{width: '18px', height: '18px', color: '#09121F', marginLeft: '11px'}}/> : <div
                    onClick={(e) => accuracy !== 'N/A' && insights.length > 0 && checkIfCanShowInsights() && openInsights(e)}
                    className={`accuracy-container ${isClicked && 'accuracy-container-active'} ${accuracy !== 'N/A' && insights.length > 0 && checkIfCanShowInsights() ? 'accuracy-pointer' : 'accuracy-default-pointer'}`}>
                    <p className={`accuracy-p ${isClicked && 'accuracy-p-active'} `}>{`${accuracy}${accuracy !== 'N/A' ? '%' : ''}`}</p>
                </div> }
            </ArrowTooltips>
        </>

    );
};

export default Accuracy;
